import { parseApiResponse, throwApiError } from '@/shared/utils/apiResponse';
import { apiGet } from '@/shared/utils/requestBuilder';

import type {
  PorteiroLotesConsulta,
  PorteiroLotesResposta,
  PorteiroObservabilidadeConsulta,
  PorteiroObservabilidadeResposta,
} from '../../types/porteiroObservabilidade';
import { paramsDaConsulta, paramsDosLotes } from '../../utils/porteiroObservabilidade';

const ROTA_DA_OBSERVABILIDADE = '/admin/platform/porteiro/observabilidade';
const ROTA_DOS_LOTES = '/admin/platform/porteiro/lotes';

export const porteiroObservabilidadeService = {
  async get(
    consulta: PorteiroObservabilidadeConsulta,
    signal?: AbortSignal,
  ): Promise<PorteiroObservabilidadeResposta> {
    const response = await apiGet(
      ROTA_DA_OBSERVABILIDADE,
      paramsDaConsulta(consulta),
      false,
      signal,
    );
    if (!response.ok) {
      await throwApiError(response, 'Erro ao carregar a observabilidade do porteiro');
    }
    return parseApiResponse<PorteiroObservabilidadeResposta>(response);
  },

  async lotes(consulta: PorteiroLotesConsulta): Promise<PorteiroLotesResposta> {
    const response = await apiGet(ROTA_DOS_LOTES, paramsDosLotes(consulta));
    if (!response.ok) {
      await throwApiError(response, 'Erro ao carregar os lotes do escritório');
    }
    return parseApiResponse<PorteiroLotesResposta>(response);
  },
};
